import { render, staticRenderFns } from "./PurchaseOrderItemsTable.vue?vue&type=template&id=1e4e8186&scoped=true"
import script from "./PurchaseOrderItemsTable.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderItemsTable.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderItemsTable.vue?vue&type=style&index=0&id=1e4e8186&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e8186",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4e8186')) {
      api.createRecord('1e4e8186', component.options)
    } else {
      api.reload('1e4e8186', component.options)
    }
    module.hot.accept("./PurchaseOrderItemsTable.vue?vue&type=template&id=1e4e8186&scoped=true", function () {
      api.rerender('1e4e8186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchase-orders/PurchaseOrderItemsTable.vue"
export default component.exports